import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DailyHarvestHero from "./sections/DailyHarvestHero";
import HeritageHospitality from "./sections/HeritageHospitality";
import LearningPathways from "./sections/LearningPathways";
import GeorgiaInfrastructureImpact from "./sections/GeorgiaInfrastructureImpact";
import InitiateCoordination from "./sections/InitiateCoordination";
import ContactDetails from "./sections/ContactDetails";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DailyHarvestHero />
      <HeritageHospitality />
      <LearningPathways />
      <GeorgiaInfrastructureImpact />
      <InitiateCoordination />
      <ContactDetails />
      <Footer />
    </div>;
}